import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link as ReactRouterLink } from "react-router-dom";
//@ts-ignore cortex
import { useQueryString } from "@cortexglobal/cortex-utilities";
///@ts-ignore cortex
import { trans } from "@cortexglobal/rla-intl";
import {
    IconTextButton,
    PageTitle,
    Loading,
    Row,
    Panel,
    useAddToast,
    //@ts-ignore cortex
} from "@cortexglobal/rla-components";
import { HeaderEmphasis, TabordionGroup } from "../../components/index";
import {
    ExternalDashboardForm,
    ExternalDashboard,
} from "../../forms/ExternalDashboardForm";

export const ExternalDashboardEdit = ({ uuid, path }) => {
    const page = useQueryString().get("page");
    const addToast = useAddToast();

    const [tab, setTab] = useState(0);
    const [item, setItem] = useState<{
        loaded: boolean;
        data?: ExternalDashboard;
    }>({
        loaded: false,
        data: null,
    });
    const getItem = () => {
        setTab(0);
        setItem({ loaded: false, data: null });
        axios.get(`/api/v1/admin/external/${uuid}`).then(({ data }) => {
            setItem({ loaded: true, data: data.data });
        });
    };

    useEffect(getItem, [uuid]);

    const submitForm = (values, setSubmitting) => {
        return axios
            .post(`/api/v1/admin/external/${uuid}`, values)
            .then(({ data }) => {
                addToast({
                    type: "success",
                    content: trans("External dashboard updated"),
                    showFor: 5000,
                });

                setSubmitting(false);

                setItem({
                    loaded: true,
                    data: data.data,
                });
            });
    };

    return (
        <div>
            <PageTitle
                title={
                    <>
                        {trans("Edit External Dashboard")}{" "}
                        <HeaderEmphasis>
                            {item.data ? item.data.name : ""}
                        </HeaderEmphasis>
                    </>
                }
            >
                <IconTextButton
                    as={ReactRouterLink}
                    to={`${path}?page=${page ? page : 1}`}
                    rotation={180}
                    showCircle={false}
                    expanded={false}
                >
                    {trans("Back to listing")}
                </IconTextButton>
            </PageTitle>

            {item.loaded ? (
                <Row>
                    <Panel style={{ paddingBottom: "0" }}>
                        <ExternalDashboardForm
                            item={item.data}
                            submitForm={submitForm}
                        />
                    </Panel>
                </Row>
            ) : (
                <Loading />
            )}
        </div>
    );
};

export default ExternalDashboardEdit;
